let Willowimg1 = "https://cdn.pixabay.com/photo/2022/11/12/10/12/ai-generated-7586654_1280.png"
let Willowimg2 = "https://cdn.pixabay.com/photo/2018/02/27/09/12/weeping-willow-3185001_1280.png"
let irchimg1 = "https://cdn.pixabay.com/photo/2021/06/08/20/30/tree-6321633_1280.png"
let irchimg2 = "https://cdn.pixabay.com/photo/2023/05/21/12/31/tree-8008457_1280.png"
let redimg1 = "https://cdn.pixabay.com/photo/2017/02/20/20/37/maple-2083869_1280.png"
let redimg2 = "https://cdn.pixabay.com/photo/2022/11/11/09/51/maple-7584635_1280.png"
let Elmimg1 = "https://cdn.pixabay.com/photo/2016/08/23/08/52/zelkova-serrata-1613784_1280.png"
let Elmimg2 = "https://cdn.pixabay.com/photo/2022/11/11/09/52/elm-7584640_1280.png"
let Elmimg3 = "https://cdn.pixabay.com/photo/2016/06/28/10/35/tree-1484370_1280.png"
let Elmimg4 = "https://cdn.pixabay.com/photo/2022/11/11/09/52/elm-7584638_640.png"
let mapleimg1 = "https://cdn.pixabay.com/photo/2022/11/11/09/51/maple-7584636_1280.png"
let mapleimg2 = "https://cdn.pixabay.com/photo/2022/11/12/10/10/ai-generated-7586649_1280.png"
let mapleimg3 = "https://cdn.pixabay.com/photo/2022/11/12/10/11/maple-7586651_1280.png"
let cherryimg1 = "https://cdn.pixabay.com/photo/2016/06/26/11/50/cherry-   lossom-tree-1480325_1280.png"
let cherryimg2 = "https://cdn.pixabay.com/photo/2018/08/06/15/34/sakura-3587773_1280.png"






export const trees = [
    {
        id: 1,
        price: 10500,
        rating: 5,
        title: "Elm Tree",
        reviews: "69,548",
        image: Elmimg1,
        height: "20m",
        width: "10m",
        description: "Elms are deciduous and semi-deciduous trees comprising the genus Ulmus in the family Ulmaceae. They are distri   uted over most of the Northern Hemisphere, inha   iting the temperate and tropical-montane regions of North America and Eurasia",
    },
    {
        id: 2,
        price: 15500,
        rating: 4.5,
        title: "Elm Tree",
        reviews: "9,538",
        image: Elmimg2,
        height: "15m",
        width: "18m",
        description: "Elms are deciduous and semi-deciduous trees comprising the genus Ulmus in the family Ulmaceae. They are distributed over most of the Northern Hemisphere, inhabiting the temperate and tropical-montane regions of North America and Eurasia",

    },
    {
        id: 3,
        price: 10500,
        rating: 5,
        title: "Mapple Tree",
        reviews: "69,548",
        image: mapleimg3,
        height: "20m",
        width: "10m",
        description: "Acer is a genus of trees and shrubs commonly known as maples. The genus is placed in the family Sapindaceae. There are approximately 132 species, most of which are native to Asia with a number also appearing in Europe, northern Africa, and North America.",
    },
    {
        id: 4,
        price: 10500,
        rating: 5,
        title: "Red Maple Tree",
        reviews: "69,548",
        image: redimg1,
        height: "20m",
        width: "10m",
        description: "also known as swamp maple, water maple, or soft maple, is one of the most common and widespread deciduous trees of eastern and central North America. The U.S. Forest Service recognizes it as the most a   undant native tree in eastern North America.",
    },
    {
        id: 5,
        price: 10500,
        rating: 5,
        title: "Willow Tree",
        reviews: "69,548",
        image: Willowimg1,
        height: "20m",
        width: "10m",

        description: "Willows, also called sallows and osiers, of the genus Salix, comprise around 350 species (plus numerous hy   rids) of typically deciduous trees and shru   s, found primarily on moist soils in cold and temperate regions.",
    },
    {
        id: 6,
        price: 10500,
        rating: 5,
        title: "Birch Tree",
        reviews: "69,548",
        image: irchimg1,
        height: "20m",
        width: "10m",
        description: "A birch is a thin-leaved deciduous hardwood tree of the genus    etula  in the family    etulaceae, which also includes alders, hazels, and horn   eams. It is closely related to the    eech-oak family Fagaceae.",
    },
    {
        id: 7,
        price: 10500,
        rating: 5,
        title: "Elm Tree",
        reviews: "69,548",
        image: Elmimg3,
        height: "20m",
        width: "10m",
        description: "Elms are deciduous and semi-deciduous trees comprising the genus Ulmus in the family Ulmaceae. They are distri   uted over most of the Northern Hemisphere, inha   iting the temperate and tropical-montane regions of North America and Eurasia",

    },
    {
        id: 8,
        price: 10500,
        rating: 5,
        title: "Red Maple Tree",
        reviews: "69,548",
        image: redimg2,
        height: "20m",
        width: "10m",
        description: "also known as swamp maple, water maple, or soft maple, is one of the most common and widespread deciduous trees of eastern and central North America. The U.S. Forest Service recognizes it as the most a   undant native tree in eastern North America.",
    },
    {
        id: 9,
        price: 10500,
        rating: 5,
        title: "Elm Tree",
        reviews: "69,548",
        image: Elmimg4,
        height: "20m",
        width: "10m",
        description: "Elms are deciduous and semi-deciduous trees comprising the genus Ulmus in the family Ulmaceae. They are distri   uted over most of the Northern Hemisphere, inha   iting the temperate and tropical-montane regions of North America and Eurasia",

    },
    {
        id: 10,
        price: 10500,
        rating: 5,
        title: "Cherry blossom Tree",
        reviews: "69,548",
        image: cherryimg2,
        height: "20m",
        width: "10m",

        description: "A cherry  blossom, also known as a Japanese cherry or sakura, is a flower of trees in the genus Prunus or the Prunus su   genus Cerasus. Wild species of the cherry tree are widely distri   uted, mainly in the Northern Hemisphere. They are common in East Asia, especially in Japan. They generally refer to ornamental cherry trees, not cherry trees grown for their fruit. The cherry    lossom is considered the national flower of Japan.",
    },
    {
        id: 11,
        price: 10500,
        rating: 5,
        title: "Birch Tree",
        reviews: "69,548",
        image: irchimg2,
        height: "20m",
        width: "10m",
        description: "A birch is a thin-leaved deciduous hardwood tree of the genus    etula  in the family    etulaceae, which also includes alders, hazels, and horn   eams. It is closely related to the    eech-oak family Fagaceae.",
    },
    {
        id: 12,
        price: 10500,
        rating: 5,
        title: "Willow Tree",
        reviews: "69,548",
        image: Willowimg2,
        height: "20m",
        width: "10m",
        description: "Willows, also called sallows and osiers, of the genus Salix, comprise around 350 species (plus numerous hy   rids) of typically deciduous trees and shru   s, found primarily on moist soils in cold and temperate regions.",

    },
    {
        id: 13,
        price: 10500,
        rating: 5,
        title: "Maple Tree",
        reviews: "69,548",
        image: mapleimg1,
        height: "20m",
        width: "10m",
        description: "Acer is a genus of trees and shru   s commonly known as maples. The genus is placed in the family Sapindaceae.[1] There are approximately 132 species, most of which are native to Asia,[2] with a num   er also appearing in Europe, northern Africa, and North America.",

    },
    {
        id: 14,
        price: 10500,
        rating: 5,
        title: "Cherry blossom Tree",
        reviews: "69,548",
        image: cherryimg1,
        height: "20m",
        width: "10m",

        description: "A cherry blossom, also known as a Japanese cherry or sakura, is a flower of trees in the genus Prunus or the Prunus su   genus Cerasus. Wild species of the cherry tree are widely distri   uted, mainly in the Northern Hemisphere. They are common in East Asia, especially in Japan. They generally refer to ornamental cherry trees, not cherry trees grown for their fruit. The cherry    lossom is considered the national flower of Japan.",

    },
    {
        id: 15,
        price: 10500,
        rating: 5,
        title: "Maple Tree",
        reviews: "69,548",
        image: mapleimg2,
        height: "20m",
        width: "10m",
        description: "Acer  is a genus of trees and shru   s commonly known as maples. The genus is placed in the family Sapindaceae.[1] There are approximately 132 species, most of which are native to Asia,[2] with a num   er also appearing in Europe, northern Africa, and North America.",

    },
]